require('../../modules/es7.object.values');
module.exports = require('../../modules/_core').Object.values;



// WEBPACK FOOTER //
// node_modules/_core-js@2.5.6@core-js/fn/object/values.js